import DateRangePicker from "@/components/DateRangePicker";
import DebouncedInput from "@/components/DebouncedInput";
import SelectFilter from "@/components/SelectFilter";
import { SimpleGrid } from "@chakra-ui/react";
import { useCallback } from "react";
import { mapMovementSourceType } from "../mappers/payouts.mapper";
import type { LedgerFiltersType } from "../types/payouts.type";

interface Props {
  queryFilters: LedgerFiltersType;
  setQueryFilters: React.Dispatch<React.SetStateAction<LedgerFiltersType>>;
}

export default function LedgerFilters({
  queryFilters,
  setQueryFilters,
}: Props) {
  const handleSourceIdChange = useCallback(
    (value: string) =>
      setQueryFilters((prev) => ({ ...prev, sourceId: value || undefined })),
    [setQueryFilters]
  );

  return (
    <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} gap={3} mb={4}>
      <SelectFilter
        placeholder="Tipo"
        options={Object.keys(mapMovementSourceType)}
        selectedOption={queryFilters.sourceType}
        onSelect={(option) =>
          setQueryFilters((prev) => ({ ...prev, sourceType: option }))
        }
        isClearable
      />
      <DateRangePicker
        values={queryFilters.dateRange}
        setValues={(range) =>
          setQueryFilters((prev) => ({ ...prev, dateRange: range }))
        }
      />
      <DebouncedInput
        placeholder="Referencia"
        size="sm"
        value={queryFilters.sourceId}
        onDebouncedChange={handleSourceIdChange}
      />
    </SimpleGrid>
  );
}
